import { render, staticRenderFns } from "./main.vue?vue&type=template&id=cce2ea00&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce2ea00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cce2ea00')) {
      api.createRecord('cce2ea00', component.options)
    } else {
      api.reload('cce2ea00', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=cce2ea00&scoped=true", function () {
      api.rerender('cce2ea00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/dashboard/partner/main.vue"
export default component.exports